/**
 * Style Adjustments
 * Seitenspezifische Style-Anpassungen
 * (Market-specific branch removed 2026-07-10: data-market is stripped from <html>,
 *  so that code was dead. See docs/UPGRADE-FUTUREPROOFING.md.)
 */

document.addEventListener("DOMContentLoaded", function () {
  const path = window.location.pathname;

  // ============================================
  // Cart Page: Hide cart drawer block
  // ============================================
  if (path === "/cart") {
    injectStyle(`
      .bmsm-cart-drawer-block {
        display: none !important;
      }
    `);
  }

  // ============================================
  // Store Locator Pages: Hide sticky announcement bar
  // ============================================
  if (
    path.includes("/pages/store-locator") ||
    path.includes("/pages/stores/")
  ) {
    injectStyle(`
      .bmsm-stickyannouncementbar {
        display: none !important;
      }
    `);
  }
  // ============================================
  // Other pages with announcement bar: Adjust floating filter
  // ============================================
  else if (document.querySelector(".bmsm-stickyannouncementbar")) {
    injectStyle(`
      .facets__floating-filter {
        transform: translateY(-60px) !important;
      }
    `);
  }

});

/**
 * Helper: Inject CSS into head
 * @param {string} css - CSS string to inject
 */
function injectStyle(css) {
  const style = document.createElement("style");
  style.textContent = css;
  document.head.appendChild(style);
}
